<template>
  <div class="ui basic placeholder segment">
    <h1 class="ui icon header">
      <i class="eye slash icon"></i>
      You are not authorized to view this content, please contact your administrator.
    </h1>
  </div>
</template>

<script>
export default {
  name: 'AccessDenied',
};
</script>
